import { Input } from "@/components/ui/input";
import icScale from "@/assets/icons/ic-scale-01.svg";

interface ScopeComparisonProps {
  title?: string;
  inScopeItems: string[];
  isEditable?: boolean;
  onInScopeChange?: (items: string[]) => void;
}

export function ScopeComparison({
  title,
  inScopeItems,
  isEditable,
  onInScopeChange,
}: ScopeComparisonProps) {
  return (
    <div className="flex flex-col gap-2 lg:gap-3">
      {title && <h2 className="text-[12px] leading-4 text-[#000000]">{title}</h2>}
      <div className="flex justify-between">
        <ScopeColumn
          title="In Scope"
          items={inScopeItems}
          indicatorColor="bg-[#2BAA50]"
          isEditable={isEditable}
          onChange={onInScopeChange}
        />
      </div>
    </div>
  );
}

interface ScopeColumnProps {
  title: string;
  items: string[];
  indicatorColor: string;
  isEditable?: boolean;
  onChange?: (items: string[]) => void;
}

function ScopeColumn({ title, items, indicatorColor, isEditable, onChange }: ScopeColumnProps) {
  const handleAddItem = () => {
    if (onChange) {
      onChange([...items, ""]);
    }
  };

  const handleRemoveItem = (index: number) => {
    if (onChange) {
      onChange(items.filter((_, i) => i !== index));
    }
  };

  const handleItemChange = (originalIndex: number, value: string) => {
    if (onChange) {
      const newItems = [...items];
      newItems[originalIndex] = value;
      onChange(newItems.filter((s) => s.trim()));
    }
  };

  const nonEmptyItems = items
    .map((content, originalIndex) => ({ content, originalIndex }))
    .filter(({ content }) => content.trim());

  return (
    <div
      className="flex flex-col gap-[12px] flex-1 p-4 lg:p-[20px] rounded"
      style={{
        backgroundColor: "white",
        border: "1px solid rgba(0, 0, 0, 0.15)",
      }}
    >
      <div className="flex items-center justify-start gap-[8px]">
        <div className={`w-[4px] h-[18px] ${indicatorColor} rounded-[8px]`} />
        <h3 className="text-base font-bold text-[#000000] leading-6 tracking-[-0.02em]">{title}</h3>
      </div>
      <div>
        {isEditable ? (
          <ul className="flex flex-col gap-3">
            {nonEmptyItems.map(({ content, originalIndex }) => (
              <li key={originalIndex} className="flex items-start gap-2 text-base text-[#]">
                <div className="flex items-center gap-2 w-full">
                  <Input
                    value={content}
                    onChange={(e) => handleItemChange(originalIndex, e.target.value)}
                    className="flex-1 h-[44px] text-sm b"
                    placeholder="항목을 입력하세요..."
                  />
                </div>
              </li>
            ))}
          </ul>
        ) : nonEmptyItems.length > 0 ? (
          <ul className="flex flex-col gap-[4px]">
            {nonEmptyItems.map(({ content, originalIndex }) => (
              <li key={originalIndex} className="flex items-start gap-2 text-base text-[#]">
                <div className="rounded-[4px] w-full flex items-start lg:items-center">
                  <div className="w-[6px] h-[6px] rounded-full bg-[#000000] mt-2 lg:mt-0 shrink-0" />
                  <span className="whitespace-pre-wrap text-[14px] leading-[20px] tracking-[-0.01em] text-[#000000] px-2">
                    {content}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-base text-[#BBBBBB]">-</p>
        )}
        {/* {isEditable && (
          <button
            onClick={handleAddItem}
            className="flex items-center gap-1 mt-2 text-sm text-[#007AFF] hover:underline"
            type="button"
          >
            <Plus size={14} /> 항목 추가
          </button>
        )} */}
      </div>
    </div>
  );
}

export { icScale };
